import React from 'react';
import BookNewCoachingSessionSidebar from 'coaching/components/CoachingHomeView/BookNewCoachingSessionSidebar';
import BoxBody from 'components/BoxBody';
import Button, { Props as ButtonProps } from 'components/Button';
import CoachingConstants from 'coaching/CoachingConstants';
import Row from 'components/Row';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import { coachingHomeEventPrefix } from 'coaching/components/CoachingHomeView/CoachingHomeView';
import { useCoachingViewState } from 'coaching/components/CoachingView';
import {
  CoachMetadata,
  CoachingSessionTools,
} from 'coaching/components/CoachingHomeView/CoachingSessionsBySubjectContainer';

type Props = {
  sessionTools?: CoachingSessionTools;
  subjectName?: string;
  previousCoaches: CoachMetadata[];
  participantUuid: string;
};

export default function CoachingNoUpcomingSessionsCard({
  sessionTools,
  subjectName,
  previousCoaches,
  participantUuid,
}: Props) {
  const { setSidebarIsOpen, setSidebar } = useCoachingViewState();
  const defaultCoach = previousCoaches[0];

  const noSessionsText = (
    <Text size="small" data-test="no-upcoming-sessions-text">
      No upcoming sessions
    </Text>
  );

  const sharedButtonProps: Partial<ButtonProps> = {
    level: 'primary',
    color: 'mascot',
    size: 'small',
    'data-test': 'schedule-session-empty-state-button',
    eventKey: `${coachingHomeEventPrefix}.book_a_session.click`,
    children: 'Book a session',
  };
  const scheduleButton =
    defaultCoach && sessionTools && subjectName ? (
      <Button
        {...sharedButtonProps}
        onClick={() => {
          setSidebar(
            <BookNewCoachingSessionSidebar
              subjectName={subjectName}
              sessionTools={sessionTools}
              coach={defaultCoach}
              onClose={() => setSidebarIsOpen(false)}
              participantUuid={participantUuid}
            />
          );
          setSidebarIsOpen(true);
        }}
      />
    ) : (
      <Button
        {...sharedButtonProps}
        target="_blank"
        href={`${CoachingConstants.COACHING_HELP_FORM_ROUTE}?request=c_new_session`}
      />
    );

  const component = userAgent.isDesktop() ? (
    <MediaObject center figure="right">
      {noSessionsText}
      {scheduleButton}
    </MediaObject>
  ) : (
    <React.Fragment>
      <Row size="small">{noSessionsText}</Row>
      {scheduleButton}
    </React.Fragment>
  );

  return <BoxBody size="small">{component}</BoxBody>;
}
